// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"1d21c190","488":"d5ac21da"}[chunkId] + ".chunk.js";
};